import ApiService from '@/common/api.service';

const url = '/v1/subjects';

const ComplexService = {
  query(filters) {
    let params = { 'filter[type]': 'complex' };

    Object.keys(filters)
      .sort()
      .forEach(key => {
        params[key] = filters[key];
      });

    return ApiService.query(url, { params: params });
  },
  get(id) {
    return ApiService.get(url, id);
  },
  delete(id) {
    return ApiService.delete(`${url}/${id}`);
  },
  save(id = null, complex) {
    if (!id) {
      return ApiService.post(url, complex);
    }
    return ApiService.update(url, id, complex);
  }
};

export default ComplexService;
